import { gql } from '@apollo/client';

export const EXPORT_ZIPCODES = gql`
  mutation ExportZipcodes($input: ZipcodeExportInput!) {
    exportZipcodes(input: $input) {
      success
      message
      downloadUrl
      recordCount
    }
  }
`;

export const IMPORT_ZIPCODES_BY_OBJECT_KEY = gql`
  mutation ImportZipcodesByObjectKey($objectKey: String!, $fileName: String!) {
    importZipcodesByObjectKey(objectKey: $objectKey, fileName: $fileName) {
      success
      message
      totalRecords
      importedRecords
    }
  }
`;



export interface ImportZipcodesByObjectKeyData {
  importZipcodesByObjectKey: {
    success: boolean;
    message: string;
    totalRecords?: number;
    importedRecords?: number;
  };
}

export interface ImportZipcodesByObjectKeyVariables {
  objectKey: string;
  fileName: string;
}

export const BATCH_UPDATE_ALLOW_TAKING_ORDER = gql`
  mutation BatchUpdateAllowTakingOrder($zipcodes: [String!]!, $allowTakingOrder: Boolean!) {
    batchUpdateAllowTakingOrder(zipcodes: $zipcodes, allowTakingOrder: $allowTakingOrder) {
      success
      message
      updatedCount
    }
  }
`;

export interface BatchUpdateAllowTakingOrderData {
  batchUpdateAllowTakingOrder: {
    success: boolean;
    message: string;
    updatedCount: number;
  };
}

export interface BatchUpdateAllowTakingOrderVariables {
  zipcodes: string[];
  allowTakingOrder: boolean;
}

export const CREATE_ZIPCODE_EXPORT_TASK = gql`
  mutation CreateZipcodeExportTask($zipcodes: [String!], $filters: ZipcodeFiltersTypeInput) {
    createZipcodeExportTask(zipcodes: $zipcodes, filters: $filters) {
      success
      fileName
      message
    }
  }
`;

export interface CreateZipcodeExportTaskData {
  createZipcodeExportTask: {
    success: boolean;
    fileName: string;
    message?: string;
  };
}

export interface CreateZipcodeExportTaskVariables {
  zipcodes?: string[] | null;
  filters?: any | null;
} 